import { Table, TableRow, TableCell, TableBody } from "../ui/table";
import { formatPercentage } from "@/lib/formatters";

type BreakdownTableItem = {
  component: string;
  amount?: string;
  percentage: number;
  indent?: boolean;
};

type BreakdownTableProps = {
  items: BreakdownTableItem[];
};

export function BreakdownTable({ items }: BreakdownTableProps) {
  return (
    <div className="card rounded-lg">
      <Table>
        <TableBody>
          {items.map((item, index) => (
            <TableRow key={`${item.component}-${index}`}>
              <TableCell
                className={item.indent ? "font-normal" : "font-medium"}
              >
                <div className={item.indent ? "pl-4" : ""}>
                  {item.component}
                </div>
              </TableCell>
              {item.amount && <TableCell>{item.amount}</TableCell>}
              <PercentageCell percentage={item.percentage} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

function PercentageCell({ percentage }: { percentage: number }) {
  return (
    <TableCell className="relative">
      <PercentageBar percentage={percentage} />
      <span className="relative">{formatPercentage(percentage)}</span>
    </TableCell>
  );
}

function PercentageBar({ percentage }: { percentage: number }) {
  return (
    <div className="absolute top-1 right-1 bottom-1 left-1">
      <div
        className="bg-chart-1 absolute top-0 bottom-0 left-0 rounded-md"
        style={{ width: `${percentage * 100}%` }}
      />
    </div>
  );
}
